export const PIPELINE_STEPS = [
  'IDLE', 'VALIDATING_VIDEO', 'LOADING_FFMPEG', 'EXTRACTING_AUDIO', 'SPLITTING_AUDIO',
  'TRANSCRIBING', 'MERGING_TRANSCRIPT', 'TRANSLATING', 'GENERATING_TTS', 'ALIGNING_AUDIO',
  'MIXING_AUDIO', 'RENDERING_VIDEO', 'COMPLETED',
] as const;
export type PipelineStep = (typeof PIPELINE_STEPS)[number];
export type AppErrorCode = 'AUTH_ERROR' | 'RATE_LIMITED' | 'NETWORK_ERROR' | 'INVALID_MEDIA' |
  'TRANSCRIPTION_ERROR' | 'TRANSLATION_ERROR' | 'TTS_ERROR' | 'FFMPEG_ERROR' |
  'OUT_OF_MEMORY' | 'STORAGE_ERROR' | 'CANCELLED' | 'EXPORT_ERROR';

export interface Cue { id: string; start: number; end: number; text: string; translatedText: string; ttsUrl?: string }
export interface VideoMeta { name: string; size: number; type: string; duration: number; width: number; height: number; videoCodec: string; audioCodec: string; frameRate?: number }
export type TranslationStyle = 'natural' | 'literal' | 'conversation' | 'cinematic' | 'narration';
export type AudioMode = 'replace' | 'mix' | 'dub-only' | 'subtitles-only';
export interface Settings {
  sourceLanguage: string; targetLanguage: string; translationStyle: TranslationStyle;
  voice: string; speechStyle: string; speed: number; audioMode: AudioMode;
  dubVolume: number; originalVolume: number; burnSubtitles: boolean; glossary: string;
  lowMemory: boolean; transcriptionModel: string; translationModel: string; ttsModel: string;
}
export interface ApiKeys { groq: string; gemini: string; remember: boolean }
export interface OutputFiles { videoUrl?: string; videoName?: string; audioUrl?: string; srtUrl?: string; vttUrl?: string; warning?: string }

export class AppError extends Error {
  constructor(public readonly code: AppErrorCode, message: string, public readonly retryable = false, public readonly technical?: string) {
    super(message); this.name = 'AppError';
  }
}
